<div class="row">

    <div class="col-12" *ngIf="staticContent">
        <div id="content"></div>
    </div>
    <div class="col-12" *ngIf="!staticContent">
        <div *ngIf="pageDynamique==='planacces'">
            <div id="content">
               <iframe width="540px" height="450px" id="MapFrame" > </iframe>

            </div>
        </div>
        <div *ngIf="pageDynamique==='mouvementnavires' ">
            <div *ngIf="selectedPort.idPort !== null &&  selectedPort.idPort !== undefined ">
                <app-mvm-navires [portId]="selectedPort.idPort" ></app-mvm-navires>
            </div>
            
                <div class="col-12" *ngIf="selectedPort.idPort === null || selectedPort.idPort === undefined ">
                    <div id="content"></div>
                </div>
 
             
             
        </div>
    </div>
  
    
</div>

